const O = (s) => s !== null && typeof s == "object", X = (s) => typeof s == "string", j = Array.isArray;
function w(s, e, f) {
  const m = (o, h) => {
    if (Object.is(o, h))
      return !0;
    if (typeof o != typeof h)
      return !1;
    if (j(o) && j(h))
      return o.length !== h.length ? !1 : o.every((y, l) => f ? m(y, h[l]) : Object.is(o, h));
    if (O(o) && O(h)) {
      const y = Object.getOwnPropertyNames(o);
      return y.length !== Object.getOwnPropertyNames(h).length ? !1 : y.every((l) => f ? m(o[l], h[l]) : Object.is(o[l], h[l]));
    }
    return !1;
  };
  return m(s, e);
}
function a(s) {
  let e, f;
  return (...m) => (w(f, m) || (e = s(...m), f = m), e);
}
const g = (s, e) => X(e) ? s * (parseFloat(e) / 100) : e, x = "LT", N = "RT", b = "LB", A = x, H = ["50%", "50%"];
function L(s, e) {
  const f = a(g), m = a(g), o = a(g), h = a(g), y = a((t, r, n) => t - r - n), l = a((t, r, n) => t - r - n), T = a((t, r, n = "50%") => g(Math.min(t, r), n)), W = a((t = A, r, n) => [b, x].includes(t) ? r : s.clientWidth - n), p = a(
    (t = H, r = A, n, i) => ([b, x].includes(r) ? n += g(i, t[0]) : n += i - g(i, t[0]), n)
  ), M = a((t = A, r, n) => [x, N].includes(t) ? r : s.clientHeight - n), P = a(
    (t = H, r = A, n, i) => ([x, N].includes(r) ? n += g(i, t[1]) : n += i - g(i, t[1]), n)
  );
  return {
    get options() {
      return e;
    },
    get clientWidth() {
      return s.clientWidth;
    },
    get clientHeight() {
      return s.clientHeight;
    },
    get top() {
      var t, r;
      return f(s.clientHeight, (r = (t = e.grid) == null ? void 0 : t.top) != null ? r : 0);
    },
    get right() {
      var t, r;
      return m(s.clientWidth, (r = (t = e.grid) == null ? void 0 : t.right) != null ? r : 0);
    },
    get bottom() {
      var t, r;
      return o(s.clientHeight, (r = (t = e.grid) == null ? void 0 : t.bottom) != null ? r : 0);
    },
    get left() {
      var t, r;
      return h(s.clientWidth, (r = (t = e.grid) == null ? void 0 : t.left) != null ? r : 0);
    },
    get width() {
      return y(s.clientWidth, this.left, this.right);
    },
    get height() {
      return l(s.clientHeight, this.top, this.bottom);
    },
    get maxRadius() {
      return e.polar ? T(this.width, this.height, e.polar.radius) : NaN;
    },
    get x() {
      return e.polar ? p(e.polar.center, e.type, this.left, this.width) : W(e.type, this.left, this.right);
    },
    get y() {
      return e.polar ? P(e.polar.center, e.type, this.top, this.height) : M(e.type, this.top, this.bottom);
    },
    coordX(t) {
      if (e.polar || !e.xAxis)
        return NaN;
      const { type: r = A, xAxis: n } = e, { x: i, width: u } = this;
      if ([b, x].includes(r)) {
        const { min: c = 0, max: d } = n;
        return i + u * (t - c) / (d - c);
      } else {
        const { min: c = 0, max: d } = n;
        return i - u * (t - c) / (d - c);
      }
    },
    coordY(t) {
      if (e.polar || !e.yAxis)
        return NaN;
      const { type: r = A, yAxis: n } = e, { y: i, height: u } = this;
      if ([x, N].includes(r)) {
        const { min: c = 0, max: d } = n;
        return i + u * (t - c) / (d - c);
      } else {
        const { min: c = 0, max: d } = n;
        return i - u * (t - c) / (d - c);
      }
    },
    radius(t) {
      if (!e.polar || !e.xAxis)
        return NaN;
      const { xAxis: r } = e, n = this.maxRadius, { min: i = 0, max: u } = r;
      return n * (t - i) / (u - i);
    },
    radian(t) {
      if (!e.polar || !e.yAxis)
        return NaN;
      const { yAxis: r, polar: n } = e, { startAngle: i = 90, clockwise: u = !0 } = n, { min: c = 0, max: d } = r;
      return (-i + (u ? 1 : -1) * 360 * (t - c) / (d - c)) * Math.PI / 180;
    },
    coord(...t) {
      let r, n;
      const i = t[0];
      if (Array.isArray(i) ? (r = i[0], n = i[1]) : (r = i, n = t[1]), e.polar) {
        const u = this.radius(r), c = this.radian(n);
        return [this.x + u * Math.cos(c), this.y + u * Math.sin(c)];
      } else
        return [this.coordX(r), this.coordY(n)];
    }
  };
}
export {
  L as createCoordinate
};
